import React, { useCallback, useMemo } from "react";
import SelectBase from "react-select";
import { OptionsType, ValueType, MenuPlacement } from "react-select/src/types";

import styles from "./styles";

export interface IOption {
  label: string;
  value: string;
}

interface IProps {
  value: string;
  options: OptionsType<IOption>;
  placeholder?: string;
  isDisabled?: boolean;
  menuPlacement?: MenuPlacement;
  handleOnChange(value: string): void;
}

export const Select: React.FC<IProps> = (
  {
    value,
    options,
    placeholder = "Select",
    isDisabled,
    menuPlacement,
    handleOnChange,
  }
) => {
  const onChange = useCallback((value: ValueType<IOption>) => {
    handleOnChange((value as IOption).value);
  }, [handleOnChange]);

  const selected = useMemo(() => (
    options.find(({ value: v }) => v === value)
  ), [value, options]);

  return (
    <SelectBase
      value={selected}
      menuPlacement={menuPlacement}
      options={options}
      styles={styles}
      isSearchable={false}
      placeholder={placeholder}
      isDisabled={isDisabled}
      onChange={onChange}
    />
  );
};
